export const reportStatusLabels = {
  not_requested: 'In attesa di acquisto / richiesta',
  delayed: 'In ritardo',
  scheduled: 'Programmato', waiting: 'In attesa', processing: 'In corso',
  complete: 'Completo', partial: 'Parziale', failed: 'Fallito', cancelled: 'Annullato',
  available: 'Disponibile, da verificare', unknown: 'Non verificabile', expired: 'Conservazione scaduta'
};

export const reportIssueLabels = {
  LIVE_START_DELAYED: 'In ritardo: diretta non ancora partita dopo 6 minuti',
  NVR_OFFLINE_DEADLINE_EXCEEDED: 'NVR senza conferma entro la scadenza',
  CONTROL_COMMAND_DEADLINE_EXCEEDED: 'Tempo massimo di esecuzione superato',
  MEDIA_UPLOAD_FAILED: 'Trasferimento fallito', UPLOAD_ACCEPTANCE_TIMEOUT: 'Upload non preso in carico',
  MEDIA_PUBLICATION_FAILED: 'Pubblicazione fallita', VIDEO_PUBLICATION_MISSING: 'Video finale non pubblicato',
  VIDEO_GAPS: 'Intervalli non registrati', VIDEO_TOO_SHORT: 'Durata inferiore al previsto',
  TRACKING_MISSING: 'Regia automatica assente', PROCESSING_DELAYED: 'Elaborazione in ritardo',
  COMPLETION_UNVERIFIED: 'Completezza non certificata', STATUS_UNKNOWN: 'Evidenze insufficienti',
  MEDIA_EXPIRED: 'Video oltre il periodo di conservazione', VIDEO_MISSING: 'Video finale assente',
  CAMERA_EXECUTION_PARTIAL: 'Acquisizione parziale', NO_RECORDING_SEGMENTS: 'Registrazione sorgente assente',
  PLAYBACK_COVERAGE_INSUFFICIENT: 'Archivio incompleto', PLAYBACK_START_TIMEOUT: 'Avvio playback scaduto',
  PHYSICAL_FIELD_BUSY: 'Campo fisico occupato',
  COMMAND_FAILED: 'Comando fallito senza codice diagnostico', COMMAND_EXPIRED: 'Comando scaduto'
};

export const romeDate = (now = new Date()) => {
  const parts = new Intl.DateTimeFormat('en', {timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(now);
  const value = type => parts.find(part => part.type === type).value;
  return `${value('year')}-${value('month')}-${value('day')}`;
};

// Spreadsheets must not interpret any user-supplied description or name as a formula.
const csvCell = value => {
  let text = value == null ? '' : String(value);
  if (/^[\s]*[=+@-]/.test(text) || /^[\t\r\n]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
};

export const videoReportCsv = events => {
  const rows = [['Evento', 'Prenotazione', 'Centro', 'Campo', 'Descrizione', 'Inizio (Europe/Rome)',
    'Fine (Europe/Rome)', 'Esito evento', 'Riuscita totale', 'Camera', 'Esito camera', 'Durata prevista (s)',
    'Durata disponibile (s)', 'Secondi mancanti', 'Errori', 'Comando', 'Stato comando']];
  const localDate = value => new Date(value).toLocaleString('it-IT', {timeZone: 'Europe/Rome', hour12: false});
  events.forEach(event => event.cameras.forEach(camera => rows.push([
    event.slotId, event.bookingId, event.partnerName, event.fieldName, event.description,
    localDate(event.startDatetime), localDate(event.endDatetime), reportStatusLabels[event.status],
    event.fullySuccessful ? 'Sì' : 'No', camera.name, reportStatusLabels[camera.status],
    event.expectedDurationSeconds, camera.durationSeconds, camera.missingSeconds,
    camera.issues.map(issue => issue.code).join(', '), camera.commandId, camera.commandStatus
  ])));
  return '\uFEFF' + rows.map(row => row.map(csvCell).join(';')).join('\r\n');
};
